import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Type,
  ViewContainerRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';

import { FormButtonComponent } from '../form-button/form-button.component';
import { FormInputComponent } from '../form-input/form-input.component';
import { FormSelectComponent } from '../form-select/form-select.component';

import { Field } from '../../models/field.interface';
import { FormHiddenComponent } from '../form-hidden/form-hidden.component';
import { FormCancelSaveComponent } from '../form-cancel-save/form-cancel-save.component';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { FormSelectCrudComponent } from '../form-select-crud/form-select.component';
import { FormImageComponent } from '../form-image/form-image.component';
import { FormInputCurrencyComponent } from '../form-input-currency/form-input.component';
import { FormInputNumberComponent } from '../form-input-number/form-input.component';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { FormSlideToggleComponent } from '../form-slide-toggle/form-slide-toggle.component';
import { InputFileComponent } from '../../../fields/input-file/input-file.component';
import { FormInputDateComponent } from '../form-input-date/form-input-date.component';
import { FormInputTextareaComponent } from '../form-input-textarea/form-input-textarea.component';
import { InputCellPhoneAreaCodeComponent } from '../../../fields/input-cellphone-area-code/input-cellphone-area-code.component';
import { InputColorComponent } from '../../../fields/input-color/input-color.component';

const components: { [type: string]: Type<Field> } = {
  button: FormButtonComponent,
  input: FormInputComponent,
  inputCurrency: FormInputCurrencyComponent,
  inputNumber: FormInputNumberComponent,
  inputFile: InputFileComponent,
  select: FormSelectComponent,
  selectCrud: FormSelectCrudComponent,
  hidden: FormHiddenComponent,
  cancelSave: FormCancelSaveComponent,
  image: FormImageComponent,
  slideToggle: FormSlideToggleComponent,
  inputDate: FormInputDateComponent,
  inputTextArea: FormInputTextareaComponent,
  inputCellPhoneAreaCode: InputCellPhoneAreaCodeComponent,
  inputColor: InputColorComponent
};

@Directive({
  selector: '[dynamicField]',
})
export class DynamicFieldDirective implements Field, OnChanges, OnInit {
  @Output()
  action: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  config: IFieldConfig;

  @Input()
  typeCes: TypeCesEnum;

  @Input()
  group: FormGroup;

  component: ComponentRef<Field>;

  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) { }

  get typeCesEnum() {
    return TypeCesEnum;
  }

  ngOnChanges() {
    if (this.component) {
      this.component.instance.config = this.config;
      this.component.instance.group = this.group;
      this.component.instance.typeCes = this.typeCes;
      this.component.instance.action = this.action;
    }
  }

  ngOnInit() {
    if (!components[this.config.type]) {
      const supportedTypes = Object.keys(components).join(', ');
      throw new Error(
        `Trying to use an unsupported type (${this.config.type}).
        Supported types: ${supportedTypes}`
      );
    }

    const component = this.resolver.resolveComponentFactory<Field>(
      components[this.config.type]
    );

    this.component = this.container.createComponent(component);
    this.component.instance.config = this.config;
    this.component.instance.group = this.group;
    this.component.instance.typeCes = this.typeCes;
    this.component.instance.action = this.action;
  }
}
